import { render, staticRenderFns } from "./CompanyUser.vue?vue&type=template&id=e37d31e8"
import script from "./CompanyUser.vue?vue&type=script&lang=js"
export * from "./CompanyUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports